<div *appCustomTitleTemplate="let title" class="flex items-center gap-4">
  <span>{{ title }}{{ tenantsAreLoading() ? ' - ' : headerTitleSuffix() }}</span>
  @if (tenantsAreLoading()) {
    <app-loading-skeleton class="w-[120px] h-[36px]" viewBox="0 0 120 36">
      <svg:rect x="0" y="0" rx="4" ry="4" width="120" height="36" />
    </app-loading-skeleton>
  }
  <app-tenant-quick-selector
    class="[&&]:hidden lg:[&&]:flex"
    [selectedTenantId]="selectedTenantId()"
    (tenantChange)="onTenantChange($event)"
  />
</div>

@if (depotOverviewCardVm(); as depotOverviewCardVm) {
  <app-depot-overview-card [vm]="depotOverviewCardVm" />
} @else if (depotOverviewCardIsLoading()) {
  <app-depot-overview-card-loading-skeleton />
}

<app-movable-cards-container class="mt-6" [vm]="cardsLayout()" (layoutChange)="onCardsLayoutChange($event)">
  <ng-container *appMovableCard="let context; key: MultiSiteDashboardCard.SiteFleetsOverview">
    @if (siteFleetsOverviewVm() || siteFleetsOverviewIsLoading()) {
      <app-site-fleets-overview-movable-panel
        cdkDrag
        [cdkDragDisabled]="siteFleetsOverviewIsLoading()"
        (cdkDragStarted)="context.onDragStarted($event)"
        (cdkDragMoved)="context.onDragMoved($event)"
        (cdkDragDropped)="context.onDragDropped($event)"
        (cdkDragEnded)="context.onDragEnded($event)"
        [vm]="siteFleetsOverviewVm()"
        [isLoading]="siteFleetsOverviewIsLoading()"
      >
        @if (!siteFleetsOverviewIsLoading()) {
          <svg-icon cdkDragHandle key="drag-32" size="32" class="cursor-grab"></svg-icon>
        }
      </app-site-fleets-overview-movable-panel>
    }
  </ng-container>

  <ng-container *appMovableCard="let context; key: MultiSiteDashboardCard.EnergyCostOverview">
    @if (energyCostOverviewVm() || energyCostOverviewIsLoading()) {
      <app-energy-cost-overview-movable-panel
        cdkDrag
        [cdkDragDisabled]="energyCostOverviewIsLoading()"
        (cdkDragStarted)="context.onDragStarted($event)"
        (cdkDragMoved)="context.onDragMoved($event)"
        (cdkDragDropped)="context.onDragDropped($event)"
        (cdkDragEnded)="context.onDragEnded($event)"
        [vm]="energyCostOverviewVm()"
        [isLoading]="energyCostOverviewIsLoading()"
        [range]="energyCostRange()"
        (rangeChange)="onEnergyCostRangeChange($event)"
      >
        @if (!energyCostOverviewIsLoading()) {
          <svg-icon cdkDragHandle key="drag-32" size="32" class="cursor-grab"></svg-icon>
        }
      </app-energy-cost-overview-movable-panel>
    }
  </ng-container>

  <ng-container *appMovableCard="let context; key: MultiSiteDashboardCard.SiteAlerts">
    @if (siteAlertsVm() || siteAlertsIsLoading()) {
      <app-site-alerts-movable-panel
        cdkDrag
        [cdkDragDisabled]="siteAlertsIsLoading()"
        (cdkDragStarted)="context.onDragStarted($event)"
        (cdkDragMoved)="context.onDragMoved($event)"
        (cdkDragDropped)="context.onDragDropped($event)"
        (cdkDragEnded)="context.onDragEnded($event)"
        [vm]="siteAlertsVm()"
        [isLoading]="siteAlertsIsLoading()"
        (sortChange)="onSiteAlertsSortChange($event)"
      >
        @if (!siteAlertsIsLoading()) {
          <svg-icon cdkDragHandle key="drag-32" size="32" class="cursor-grab"></svg-icon>
        }
      </app-site-alerts-movable-panel>
    }
  </ng-container>

  <ng-container *appMovableCard="let context; key: MultiSiteDashboardCard.ChargersOverview">
    @if (chargersOverviewVm() || chargersOverviewIsLoading()) {
      <app-chargers-overview-movable-panel
        cdkDrag
        [cdkDragDisabled]="chargersOverviewIsLoading()"
        (cdkDragStarted)="context.onDragStarted($event)"
        (cdkDragMoved)="context.onDragMoved($event)"
        (cdkDragDropped)="context.onDragDropped($event)"
        (cdkDragEnded)="context.onDragEnded($event)"
        [vm]="chargersOverviewVm()"
        [isLoading]="chargersOverviewIsLoading()"
      >
        @if (!chargersOverviewIsLoading()) {
          <svg-icon cdkDragHandle key="drag-32" size="32" class="cursor-grab"></svg-icon>
        }
      </app-chargers-overview-movable-panel>
    }
  </ng-container>

  <ng-container *appMovableCard="let context; key: MultiSiteDashboardCard.VehicleStateOfChargeSummary">
    @if (vehicleSocSummaryVm() || vehicleSocSummaryIsLoading()) {
      <app-vehicle-state-of-charge-summary-movable-panel
        cdkDrag
        [cdkDragDisabled]="vehicleSocSummaryIsLoading()"
        (cdkDragStarted)="context.onDragStarted($event)"
        (cdkDragMoved)="context.onDragMoved($event)"
        (cdkDragDropped)="context.onDragDropped($event)"
        (cdkDragEnded)="context.onDragEnded($event)"
        [vm]="vehicleSocSummaryVm()"
        [isLoading]="vehicleSocSummaryIsLoading()"
        [range]="vehicleSocSummaryRange()"
        (rangeChange)="onVehicleSocSummaryRangeChange($event)"
      >
        @if (!vehicleSocSummaryIsLoading()) {
          <svg-icon cdkDragHandle key="drag-32" size="32" class="cursor-grab"></svg-icon>
        }
      </app-vehicle-state-of-charge-summary-movable-panel>
    }
  </ng-container>
</app-movable-cards-container>
